<div class="container">
  <ng-container>
    <div class="container-content">
      @if (v3SpanReport() && v3SpanReport().isDeviated) {
        <gc-pill [color]="'critical'">
          {{ 'reportInfo.deviation' | translate }}
        </gc-pill>
      }
      <div class="span-header-row">
        <span> <strong>ID:</strong> {{ properties.serialNumber }}</span>
        <app-popup-pdf-download-trigger
          [isLoading]="pdfController.isPdfDownloadInProgress"
          [tooltip]="downloadTooltipLabel"
          (trigger)="onDownloadPreviewPdf($event)"
          (triggerKeydown)="onDownloadPreviewPdfKeyDown($event)"
        />
      </div>
      @if (showExpandedSpanDetails) {
        <div>
          <div class="container-content">
            <span>
              <strong>{{ 'popup.spanStatus' | translate }}:</strong>
              @if (v3SpanReport()) {
                {{ 'reportStatus.' + v3SpanReport().status | translate }}
              } @else if (existingSpan) {
                {{ status | translate }}
              } @else {
                {{ 'reportStatus.PLANNED' | translate }}
              }
            </span>
            <span
              ><strong>{{ 'popup.accommodationMethod' | translate }}:</strong>
              {{ accommodationMethod }}</span
            >
            <span>
              <strong>{{ 'popup.permissionType' | translate }}:</strong>
              {{ permissionType }}</span
            >
            <span>
              <strong>{{ 'popup.length' | translate }}:</strong>
              {{ lengthWithZeroDecimals }} m</span
            >
            <app-span-duct
              [spanId]="properties.spanId"
              class="ducts-containers"
            ></app-span-duct>
          </div>
        </div>
      }
      <div
        (click)="toggleExpandableContent()"
        (keydown.enter)="toggleExpandableContent()"
        class="toggle-expandable-content-container"
      >
        <p>
          {{
            (showExpandedSpanDetails
              ? 'popup.hideExpandedContent'
              : 'popup.expandContent'
            ) | translate
          }}
        </p>
        <svg
          ipo-svg-icon
          [icon]="showExpandedSpanDetails ? 'arrowUp' : 'arrowDown'"
          class="arrow-icon"
        ></svg>
      </div>
      <div class="dashed-line"></div>
      @if (
        v3SpanReport() &&
        !(properties.permissionTypeId | isPropertySpan) &&
        !(properties.accommodationMethodId | isExistingSpan)
      ) {
        <div class="edit-spans-button-wrapper">
          <gc-button
            [variant]="'utility'"
            [size]="'small'"
            [icon]="'penToSquare'"
            [iconPosition]="'left'"
            (clicked)="enterSelectSpanMode(true)"
            >{{ 'popup.editSpans' | translate }}</gc-button
          >
        </div>
      }
    </div>
  </ng-container>
</div>

<app-popup-button-container
  [primaryButtonText]="!v3SpanReport() ? 'report.create' : 'report.open'"
  [secondaryButtonText]="'close'"
  [excludePrimaryButton]="
    (properties.permissionTypeId | isPropertySpan) ||
    (properties.accommodationMethodId | isExistingSpan)
  "
  (primaryButtonClick)="
    !v3SpanReport() ? enterSelectSpanMode(false) : openSpanV2ReportPage()
  "
  (secondaryButtonClick)="onClosePopup()"
/>
